import React from 'react';

import Otherbody from './otherbody';
import Dentalbody from './dentalbody';
import './index.scss';

const WebchatPreview = ({message,logo,business_name,assistant_name,actioncolor,brandcolor,usermessage,emailInit, email_capture_message,auth}) => {
    console.log('auth',auth);
    return (
    <div className="brand_preview">
                    <div className="preview-container">
                        <div className="preview-header" style={{backgroundColor:brandcolor}}>
                            <div>
                                <div className="business-name">{business_name}</div>
                                <div className="studio-assistant">{assistant_name}</div>
                            </div>
                            <div className="down-button">
                                <span><i className="material-icons down-icon">expand_more</i></span>
                            </div>
                        </div>
                        {(auth && auth.domain !== 'DENTAL')?
                                (<Otherbody
                                    message = {message}
                                    logo = {logo}
                                    business_name={business_name}
                                    actioncolor={actioncolor}
                                    brandcolor={brandcolor}
                                    usermessage={usermessage}
                                    emailInit={emailInit}
                                    email_capture_message={ email_capture_message}
                                />):
                                (<Dentalbody 
                                    message = {message}
                                    logo = {logo}
                                    business_name={business_name}
                                    actioncolor={actioncolor}
                                    brandcolor={brandcolor}
                                    usermessage={usermessage}
                                    emailInit={emailInit}
                                    email_capture_message={ email_capture_message}
                                />)}
                                
                        {(auth && auth.domain !== 'DENTAL')?
                            (
                                <div className="preview-footer">
                            <div className="message-input">
                                <div className="message-area"><input placeholder="Type your message here"/></div>
                                <div className="send-icon"><i className="material-icons">send</i></div>
                            </div>
                            <div className="attachment-area">
                                <div className="attach-icons"><i className="material-icons">sentiment_satisfied</i>
                                 <i className="material-icons">attach_file</i></div>
                                <div className="powerd-by">powered by <span>TrueLark</span></div>
                            </div>
                            </div>
                            ):(
                            <div className="dental-footer-container">
                            <div className="dental-footer">
                                <div className="powerd-by">powered by <span>TrueLark</span></div>
                            </div>
                            </div>
                            )}
                    </div>
                    <div className="preview-close">
                        <div className="close-icon" style={{backgroundColor:actioncolor}}>
                            {/* <i className="fas fa-times close-icon" style={{backgroundColor:actioncolor}}></i> */}
                            
                            <svg
                                width="22"
                                height="23"
                                viewBox="0 0 22 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M21.7051 6.00082C21.7051 2.68666 19.0184 0 15.7043 0H6.00082C2.68666 0 0 2.68666 0 6.00082V12.6983C0 16.0125 2.68666 18.6992 6.00082 18.6992H10.3844H14.768C16.1386 18.6992 17.8786 19.5607 19.9451 21.3479L21.7051 22.87V6.00082ZM15.7044 2.12802C17.8433 2.12802 19.5772 3.86196 19.5772 6.00089V18.3673C17.8501 17.179 16.2531 16.5713 14.7681 16.5713H6.00089C3.86196 16.5713 2.12802 14.8373 2.12802 12.6984V6.00089C2.12802 3.86196 3.86196 2.12802 6.00089 2.12802H15.7044ZM6.17108 8.29893V6.59657H15.8989V8.29893H6.17108ZM6.17108 10.8526V12.555H12.9805V10.8526H6.17108Z"
                                    fill="white"
                                />
                                </svg>
                        </div>
                    </div>
                </div>
  );
};

export default WebchatPreview;
